import React, { createContext, Fragment, useContext, useEffect, useState } from "react";
import { Alert, Col, Container, Image, Row, Tab, Table, Tabs } from "react-bootstrap";
import GoBackBtn from "../../../../components/buttons/GoBackBtn";
import { useTranslation } from "react-i18next";
import { postMethod } from "../../../../requests";
import "./userDetails.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import UserDetailsClasses from "./UserDetailsClasses";
import UserDetailsPasses from "./UserDetailsPasses";
import UserDetailsGeneral from "./UserDetailsGeneral";
import UserDetailsTransactions from "./UserDetailsTransactions";
import $ from "jquery";
import { faSpinner, faWarning } from "@fortawesome/free-solid-svg-icons";
import { BasicContext } from "../../../../App";
export const UDContext = createContext();

const UserDetails = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const { showView, checkServerData } = useContext(BasicContext);
    const [user, setUser] = useState(null);
    const [alert, setAlert] = useState(null);
    const [showOnlyGeneralDetails, setShowOnlyGeneralDetails] = useState(false);
    const [balance, setBalance] = useState(null);
    const [activeTab, setActiveTab] = useState(null);

    const getUserDetails = async (tabName) => {
        const res = await postMethod("/user-details", { userID: showView.params.userID });
        if (checkServerData(res)) {
            if (res.data.code === "userDoesNotExist") {
                setAlert({ variant: "warning", message: t("warning.userDoesNotExist"), icon: faWarning });
            } else {
                setUser(res.data.userData);
                setBalance(res.data.balance);
                setShowOnlyGeneralDetails(res.data.showOnlyGeneralDetails);
            }
        }
        setActiveTab(tabName ? tabName : "classes");
        setLoading(false);
    };

    const reloadData = (tabName) => {
        setLoading(true);
        setTimeout(() => {
            getUserDetails(tabName);
        }, 200);
    };

    const handleSetContainerHeight = () => {
        $("section").css("min-height", `${window.innerHeight - $("#footerMain").outerHeight() - 61}px`);
    };

    useEffect(() => {
        handleSetContainerHeight();
        window.removeEventListener("resize", handleSetContainerHeight);
        getUserDetails(showView.params.tabName ? showView.params.tabName : null);
        // eslint-disable-next-line
    }, []);

    const tabs = [
        {
            key: "classes",
            title: t("classes.classes"),
            module: <UserDetailsClasses />,
        },
        {
            key: "passes",
            title: t("passes.passes"),
            module: <UserDetailsPasses />,
        },
        {
            key: "general",
            title: t("general"),
            module: <UserDetailsGeneral user={user} />,
        },
        {
            key: "transactions",
            title: t("transactions.transactions"),
            module: <UserDetailsTransactions />,
        },
    ];

    return (
        <section>
            <GoBackBtn classN="bg-white" />
            <UDContext.Provider value={{ reloadData }}>
                <Container fluid="lg" id="userDetails" className="bg-white">
                    <Row>
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <h1 className="h5 d-inline-block m-0 pt-2">{t("users.userDetails")}</h1>
                        </Col>
                        {loading ? (
                            <Col xs={12} className="text-center">
                                <p className="h4">
                                    {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                </p>
                            </Col>
                        ) : !user ? (
                            <Col xs={12}>
                                <Alert variant={alert.variant}>
                                    <FontAwesomeIcon icon={alert.icon} className="me-2" />
                                    {t(alert.message)}
                                </Alert>
                            </Col>
                        ) : (
                            <Fragment>
                                <Col xs={12} className="px-0 px-lg-3">
                                    <Table borderless className="mb-3">
                                        <tbody>
                                            <tr>
                                                <td className="p-0 p-lg-2 align-middle ps-1 text-center">
                                                    {user.user_avatar_name ? (
                                                        <Image
                                                            src={`${process.env.REACT_APP_API_URL}/uploads/usersAvatars/${user.user_avatar_name}`}
                                                            alt={`${user.user_name} ${user.user_surname} avatar`}
                                                            className="user-avatar"
                                                        />
                                                    ) : (
                                                        <div className="no-user-avatar mx-auto">
                                                            <FontAwesomeIcon icon={faUser} />
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="py-0 py-lg-2">
                                                    <p className="user-name mb-1 mb-lg-3">
                                                        {user.user_name} {user.user_surname}
                                                    </p>
                                                    <p className="user-role mb-lg-3 mb-2">{user.user_role_name_list.replace("/-ka", "")}</p>
                                                    {user.user_instagram && (
                                                        <p className="text-insta mb-lg-3 mb-1">
                                                            <FontAwesomeIcon icon={faInstagram} className="me-2" />
                                                            <a href={`https://instagram.com/${user.user_instagram}`} target="_blank" rel="noreferrer">
                                                                {user.user_instagram}
                                                            </a>
                                                        </p>
                                                    )}
                                                    <p className="text-small d-inline opacity-50">
                                                        {t("users.lastLoginDate")}: {user.last_login_date ? user.last_login_date : t("never")}
                                                        <br />
                                                        {t("transactions.balance")}:{" "}
                                                    </p>
                                                    <p className={`text-small d-inline ${balance >= 0 ? "opacity-50" : ""}`}>
                                                        {balance !== null ? (
                                                            <span className={balance < 0 ? "text-danger text-bold" : ""}>
                                                                {balance.toFixed(2).toString().replace(".", ",")} {t("currency")}
                                                            </span>
                                                        ) : null}
                                                    </p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                {showOnlyGeneralDetails ? (
                                    <UserDetailsGeneral user={user} onlyGeneralDetails />
                                ) : (
                                    <Col xs={12} className="px-0 mb-3">
                                        <Tabs defaultActiveKey={activeTab} id="userDetailsTabs" className="sticky-top">
                                            {tabs.map((t, k) => (
                                                <Tab key={k} eventKey={t.key} title={t.title}>
                                                    {t.module}
                                                </Tab>
                                            ))}
                                        </Tabs>
                                    </Col>
                                )}
                            </Fragment>
                        )}
                    </Row>
                </Container>
            </UDContext.Provider>
        </section>
    );
};

export default UserDetails;
